import React from 'react';
import useTheme from 'threads5/styles/useTheme';
import { getDesignTokens } from 'src/components-v2/theme';
import createTheme from 'threads5/themes/create-theme';

// getDesignTokens is deterministic per mode, so the built themes can be shared
// process-wide: every section on a page reuses one theme object per mode, which
// also lets emotion reuse its style cache across sections instead of
// partitioning it per ThemeProvider instance
const themeCache = new Map();

// TODO: consider only returning the new theme if the template is set to web 3.0
// so that gradients do not apply until explicitly set to web 3.0
// [redacted]#####################################
export const useComponentTheme = (mode) => {
  const theme = useTheme();
  const componentTheme = React.useMemo(() => {
    if (!themeCache.has(mode)) {
      // @ts-ignore
      themeCache.set(mode, createTheme({ ...getDesignTokens(mode) }));
    }
    return themeCache.get(mode);
  }, [mode]);

  return componentTheme || theme;
};
